<template>
  <button @click="$emit('close')">
    <img src="https://www.foundersport.com/assets/1/6/close-outline.png" alt="close button" />
  </button>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
button {
  background: $grey-lightest !important;
}
</style>